import { useRegisterSW } from 'virtual:pwa-register/react';
import { keyframes } from '@mui/system';
import { Fab, Tooltip } from '@mui/material';
import { Update } from '@mui/icons-material';

const intervalMS = 60 * 1000 // 1 minute

const pulse = keyframes`
  0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }`;

function CheckAppVersionV2() {
    const {
        needRefresh: [needRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegisteredSW: (_url, r) => {
            r && setInterval(() => {
                console.log('Checking for sw update');
                r.update()
            }, intervalMS)
        },
        onRegisterError(error) {
            console.error('Error al registrar el Service Worker:', error);
        },
    });

    if (!needRefresh) return null;

    return (
        <Tooltip
            title={
                'Se ha detectado una nueva versión del sistema, haga click en el botón para aplicarla o presiona las teclas ctrl + f5.'
            }
            placement="left"
        >
            <Fab
                aria-label="Actualizar aplicación"
                color="error"
                focusRipple
                onClick={() => updateServiceWorker(true)}
                sx={{
                    position: 'fixed',
                    bottom: 20,
                    right: 20,
                    animation: `${pulse} 2s ease-in-out infinite`,
                }}
            >
                <Update color="inherit" fontSize="large" />
            </Fab>
        </Tooltip>
    );
}

export default CheckAppVersionV2;
